import { SurveyStatuses } from '../shared/survey-statuses';

export interface SurveyBreakModel {
  heading: string;
  subHeading: string;
  waitText: string;
  groupIndex?: number;
  surveyStatus?: SurveyStatuses;
}
